/**
 * Account
 */

import {needJquery} from '../../../../shared/utils/index';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator    from '../../../../shared/dom/manipulator';
import EventHandler   from '../../../../shared/dom/event-handler';
import Drawer from "../../../../shared/components/drawer/drawer";
import AjaxRequest from "../../../../shared/utils/ajax";

import Login from '../login/login';

// -------
// Private
// -------

const renderDrawer = (container, toggleCollection) => {
	const AccountDrawer = new Drawer(container);

	$(document).on('click', '[data-drawer-account]', function(event) {
		event.preventDefault();

		AccountDrawer.show();
	});
};

// -------
// Public
// -------

const buildAccount = (o) => {
	const collection = o.account.collection;
	const user = o.account.user;
	const defaultLinks = o.account.links.default;
	const userLinks = o.account.links.user;

	if(defaultLinks) {
		const pageHeaderUserName = SelectorEngine.findOne('#page-header .user-name');
		const drawerHeader       = SelectorEngine.findOne('#page-account .drawer__header .drawer-title');
		const drawerBodyNav      = SelectorEngine.findOne('#page-account .drawer__body .nav.account-nav > .nav-list');

		const menuDefault = Manipulator.createElementFrom('<div class="menu-usergroup"/>');
		const menuUser = Manipulator.createElementFrom('<div class="menu-user"/>');
		const divider = Manipulator.createElementFrom('<hr>');

		let hasUser = false;

		if(!pageHeaderUserName) return;

		if(user && collection) {
			pageHeaderUserName.innerHTML = `<span>${collection.full_name}</span><span>${user.full_name}</span>`;
			hasUser = true;
		} else if(user) {
			pageHeaderUserName.innerHTML = `<span>${user.full_name}</span><span>Meine Daten</span>`;
			hasUser = true;
		} else if(collection) {
			pageHeaderUserName.innerHTML = `<span>${collection.full_name}</span>`;
		} else {
			console.log('no collection user & no default user.');
		}

		if(drawerBodyNav) {
			drawerBodyNav.innerHTML = '';

			if (Object.entries(defaultLinks).length > 0) {
				for (const [key, value] of Object.entries(defaultLinks)) {
					const link = Manipulator.createElementFrom(`<li class="nav-item"><a class="nav-link" href="${value.href}">${value.label}</a></li>`);
					Manipulator.elementAppend(link, menuDefault);
				}

				Manipulator.elementAppend(menuDefault, drawerBodyNav);
			}

			if (Object.entries(userLinks).length > 0) {
				for (const [key, value] of Object.entries(userLinks)) {
					let href = hasUser ? value.href : value.redirect;

					const link = Manipulator.createElementFrom(`<li class="nav-item"><a class="nav-link" href="${href}">${value.label}</a></li>`);
					Manipulator.elementAppend(link, menuUser);
				}

				Manipulator.elementAppend(divider, drawerBodyNav);
				Manipulator.elementAppend(menuUser, drawerBodyNav);
			}
		}
	}
};

const init = () => {
	const container        = SelectorEngine.findOne(`.drawer#page-account`);
	const toggleCollection = SelectorEngine.find(`[data-drawer-account]`);

	if(container && toggleCollection) {
		renderDrawer(container, toggleCollection);
	}
};

// -------
// Export
// -------

export default {
	init         : init,
	buildAccount : buildAccount
};